import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Drawer } from "antd";

const DocumentModal = (props, ref) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({});

  useImperativeHandle(ref, () => ({
    open(res) {
      setData(res);
      setOpen(true);
    },
  }));

  const onClose = () => {
    setOpen(false);
  };

  const url = data?.fileUrl?.includes(".pdf")
    ? data?.fileUrl?.replace("http:", "https:")
    : `https://view.officeapps.live.com/op/embed.aspx?src=${data?.fileUrl}`;

  return (
    <Drawer
      width="100%"
      title={data?.name}
      closable={{ "aria-label": "Close Button" }}
      onClose={onClose}
      open={open}
      bodyStyle={{ padding: 0, height: "100%" }}
    >
      <div style={{ height: "100%", display: "flex" }}>
        <iframe
          src={url}
          style={{ flex: 1, border: "none" }}
          title="Document Viewer"
        />
      </div>
    </Drawer>
  );
};

export default forwardRef(DocumentModal);
